import React, { Fragment, useState } from 'react'
import AppURL from '../../../constants/AppURL';
import useFetchData from '../../../helpers/useFetch';
import ConsumerEmiListView from '../../../components/front_office/emi_rpt/ConsumerEmiListView';

const EMIPaymentReportListView = () => {
    const [onURL, setOnURL] = useState(AppURL.FrontOfficeURL + 'front/customer/emi/report/list/view/');
    const { data, loading, error } = useFetchData(onURL);
  return (
    <Fragment>
        <ConsumerEmiListView data={data} error={error} loading={loading} setOnURL={setOnURL} />
    </Fragment>
  )
}

export default EMIPaymentReportListView